import makeValidationSchema from './ACEHighwayInsuranceMakeValidationSchema'
import { components } from 'cng-web-lib'
import React, { useCallback } from 'react'
import Grid from '@material-ui/core/Grid'

const {
  form: {
    field: { CngTextField, CngSwitchField }
  }
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  clientCode: '',
  module: 'SBCI'
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ index }) {
  const getFieldName = useCallback((field) => {
    return typeof index === 'number'
      ? `userInsuranceDetails.${index}.${field}`
      : field
  }, [])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <CngTextField
          name={getFieldName('insuranceCompany')}
          label='Insurance Company'
          isRequired
          size='small'
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CngTextField
          name={getFieldName('insurancePolicyNo')}
          label='Insurance Policy No.'
          isRequired
          size='small'
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CngTextField
          name={getFieldName('liabilityAmount')}
          label='Liability Amount'
          isRequired
          size='small'
          type='numeric'
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CngTextField
          name={getFieldName('yearOfIssuance')}
          label='Year of Issuance'
          isRequired
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <CngSwitchField label='Enabled' name={getFieldName('insuranceFlag')} />
      </Grid>
    </Grid>
  )
}

const ACEHighwayInsuranceFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default ACEHighwayInsuranceFormProperties
